module.exports = __webpack_public_path__ + "static/img/icon_pyq@2x.8fdd6082.png";